import React, { useState } from 'react';
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import style from './contact.module.css'
import { postMyData } from '../../../pages/api/fetchHelper'
const CustomButton = dynamic(() => import('../../buttons/customButton'))
const AlertModal = dynamic(() => import('../../modals/modalAlert'))


export default function ContactForm() {
    const router = useRouter()
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false);
    const [message, setMessage] = useState('')
    const [disabled, setDisabled] = useState(false)
    const formik = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            phone: '',
            comments: '',
            email: '',
        },
        validationSchema: Yup.object({
            firstname: Yup.string().matches(/^[A-Za-z\s]+$/, 'Accept only characters!')
                .max(50, 'Must be 50 characters or less')
                .required('Required'),
            lastname: Yup.string().matches(/^[A-Za-z\s]+$/, 'Accept only characters!').max(50, 'Must be 50 characters or less'),
            phone: Yup.string().matches(/^[0-9-*+]+$/, 'Accept only numbers!').max(20, 'Must be less than 20 characters'),
            comments: Yup.string().matches(/^[a-zA-Z0-9!:;\-.,?\s*]+$/, 'Do not accept special characters!')
                .max(300, 'Must be 300 characters or less')
                .min(20, 'Must be more than 20 caracters')
                .required('Required'),
            email: Yup.string().email('Invalid email address').required('Required'),
        }),
        onSubmit: async (values) => {
            setDisabled(true)
            try {
                const data = {
                    firstname: values.firstname.trim(),
                    lastname: values.lastname.trim(),
                    comments: values.comments.trim(),
                    phone: values.phone.trim(),
                    email: values.email.trim()
                }
                let resp = await postMyData('/api/contactUsApi', data)
                await setMessage(resp)
                await setShow(true)
                await setTimeout(() => router.push('/'), 6000)
                await setDisabled(false)
            } catch (e) {
                console.log(e)
            }
        },
    });
    return (
        <Row>
            <Col>
                <AlertModal
                    show={show}
                    alert={message}
                    handleClose={handleClose}
                />
                <form onSubmit={formik.handleSubmit}>
                    <label htmlFor="firstName">First Name</label><br />
                    <input
                        id="fullName"
                        className={style.formInputs}
                        name="firstname"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firstname}
                    />
                    {formik.touched.firstname && formik.errors.firstname ? (
                        <div className={style.errorColor}>{formik.errors.firstname}</div>
                    ) : null}
                    <br />

                    <label htmlFor="firstName">Last Name</label><br />
                    <input
                        id="lastName"
                        className={style.formInputs}
                        name="lastname"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lastname}
                    />
                    {formik.touched.lastname && formik.errors.lastname ? (
                        <div className={style.errorColor}>{formik.errors.lastname}</div>
                    ) : null}
                    <br />

                    <label htmlFor="firstName">Phone</label><br />
                    <input
                        id="lastName"
                        className={style.formInputs}
                        name="phone"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.phone}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                        <div className={style.errorColor}>{formik.errors.phone}</div>
                    ) : null}
                    <br />

                    <label htmlFor="email">Email Address</label><br />
                    <input
                        id="email"
                        className={style.formInputs}
                        name="email"
                        type="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email ? (
                        <div className={style.errorColor}>{formik.errors.email}</div>
                    ) : null}
                    <br />
                    <label htmlFor="comments">Comments</label><br />
                    <textarea
                        id="message"
                        className={style.formInputs}
                        name="comments"
                        type="text"
                        rows="6"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.comments}
                    />
                    {formik.touched.comments && formik.errors.comments ? (
                        <div className={style.errorColor} >{formik.errors.comments}</div>
                    ) : null}<br />
                    <CustomButton type="submit" maroonBtn disabled={disabled}>Submit</CustomButton>
                </form>
            </Col>
        </Row>);
};